import { lazyPage } from '../../utils/lazyPage';

const NBABestPicksToday = lazyPage(() => import('./BestPicksToday'));
const NBAmoneyline = lazyPage(() => import('./NBAmoneyline/NBAmoneyline'));
const NBAspread = lazyPage(() => import('./NBAspread/NBAspread'));
const NBAtotal = lazyPage(() => import('./NBAtotal/NBAtotal'));
const NBAPlayerProps = lazyPage(() => import('./NBAPlayerProps/NBAPlayerProps'));

const nbaRoutes = [
  {
    path: '/nba/best-picks-today',
    label: 'Best Edges Today',
    renderer: (params = {}) => <NBABestPicksToday {...params} />,
    hidden: true
  },
  {
    path: '/nba/moneyline',
    label: 'Moneylines',
    renderer: (params = {}) => <NBAmoneyline {...params} />
  },
  {
    path: '/nba/spread',
    label: 'Spreads',
    renderer: (params = {}) => <NBAspread {...params} />
  },
  {
    path: '/nba/total',
    label: 'Totals',
    renderer: (params = {}) => <NBAtotal {...params} />
  },
  {
    path: '/nba/player-props',
    label: 'Player Props',
    renderer: (params = {}) => <NBAPlayerProps {...params} />
  }
];

export default nbaRoutes;